import React from 'react'
import Stats from './Stats'

const Home = () => {
  return <Stats />
}

export default Home
